import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text, Icon } from 'primitive-components';
import { colors } from 'bench-style-constants';
import SegmentEditorContainer from './SegmentEditorContainer';

const InfoTextContainer = styled.div`
  color: ${colors.cloud};
  display: flex;
  max-width: 42rem;
  padding: 8px 0;
  position: ${props => props.position};
`;

const StyledInfoText = styled(Text)`
  color: ${colors.cloud};
`;

const StyledIcon = styled(Icon)`
  fill: ${colors.cloud};
  margin-right: 4px;
  position: relative;
  top: 0.25rem;
`;

const ExplainerText = styled(Text)`
  flex-basis: ${props => props.flexBasis || '100%'};
  order: ${props => props.order};
  max-width: 42rem;
  padding: 8px 0;
  position: ${props => props.position};
`;

const CategorySelectionWrapper = styled.div`
  padding: 8px 16px;
  width: 100%;
`;

/**
 * Component for informational text in SegmentCategorySelector component.
 */
export const InfoText = ({ text }) => (
  <InfoTextContainer>
    <StyledIcon icon="information" size="small" />
    <StyledInfoText size="small">{text}</StyledInfoText>
  </InfoTextContainer>
);

InfoText.propTypes = {
  text: PropTypes.string.isRequired,
};

/**
 * Component wrapper for selecting single segment category and assigning tags.
 */
const SegmentCategorySelector = ({
  explainerText,
  tipText,
  showEditor,
  categoryData,
  isInitialEditor,
}) => {
  const { clientId, availableCategories, segmentCategory } = categoryData;
  const explainer = explainerText();

  return (
    <CategorySelectionWrapper>
      {explainer && <ExplainerText>{explainer}</ExplainerText>}
      {showEditor && (
        <SegmentEditorContainer
          clientId={clientId}
          availableCategories={availableCategories}
          segmentCategory={segmentCategory}
          startWithOpenCategorySelect
          isInitialEditor={isInitialEditor}
        />
      )}
      {tipText && <InfoText text={tipText} />}
    </CategorySelectionWrapper>
  );
};

SegmentCategorySelector.propTypes = {
  explainerText: PropTypes.func,
  tipText: PropTypes.string,
  showEditor: PropTypes.bool,
  categoryData: PropTypes.shape({
    clientId: PropTypes.string,
    availableCategories: PropTypes.arrayOf(PropTypes.object),
    segmentCategory: PropTypes.object,
  }).isRequired,
  isInitialEditor: PropTypes.bool,
};

SegmentCategorySelector.defaultProps = {
  showEditor: false,
  isInitialEditor: false,
  explainerText: () => false,
  tipText: '',
};

export default SegmentCategorySelector;
